module.exports = __webpack_public_path__ + "img/xunjian.eb329188.svg";